module.exports = __webpack_public_path__ + "static/media/filter-icon.afbd1a15.svg";